/**
 * Buy Box V6 - Universal Product Buy Box
 * Gallery, dynamic variant/option selection, quantity, and cart logic.
 * Pricing updates dynamically on variant change.
 */
(function() {
  'use strict';

  function init() {
    document.querySelectorAll('.buy-box-v6').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if (section) {
      var boxes = section.querySelectorAll('.buy-box-v6');
      if (boxes.length > 0) boxes.forEach(initBuyBox);
    }
  });

  function initBuyBox(container) {
    if (container._bb6Initialized) return;
    container._bb6Initialized = true;

    // Parse variant JSON
    var jsonEl = container.querySelector('.buy-box-v6__variant-json');
    var variants = [];
    if (jsonEl) {
      try { variants = JSON.parse(jsonEl.textContent); } catch(e) { console.error('V6: Bad variant JSON', e); }
    }

    initGallery(container);
    initOptionSelection(container, variants);
    initQuantity(container);
    initCta(container, variants);
    initSocialProofScroll(container);
  }

  /* ========== Social Proof Scroll ========== */
  function initSocialProofScroll(container) {
    var el = container.querySelector('.buy-box-v6__social-proof--clickable');
    if (!el) return;
    var id = el.dataset.reviewsId;
    if (!id) return;
    el.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ========== Gallery ========== */
  function initGallery(container) {
    var gallery = container.querySelector('.buy-box-v6__gallery');
    if (!gallery) return;

    var images = gallery.querySelectorAll('.buy-box-v6__gallery-image');
    var thumbnails = gallery.querySelectorAll('.buy-box-v6__thumbnail');
    var prevBtn = gallery.querySelector('.buy-box-v6__gallery-arrow--prev');
    var nextBtn = gallery.querySelector('.buy-box-v6__gallery-arrow--next');
    var counter = gallery.querySelector('.buy-box-v6__gallery-current');

    if (images.length === 0) return;
    var currentIndex = 0;

    function showImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      images.forEach(function(img, i) {
        img.classList.toggle('buy-box-v6__gallery-image--active', i === currentIndex);
      });
      thumbnails.forEach(function(thumb, i) {
        thumb.classList.toggle('buy-box-v6__thumbnail--active', i === currentIndex);
      });
      if (counter) counter.textContent = currentIndex + 1;
    }

    container._bb6ShowImage = showImage;

    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); showImage(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); showImage(currentIndex + 1); });

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        showImage(parseInt(this.dataset.index, 10));
      });
    });

    gallery.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      else if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    var touchStartX = 0;
    var galleryMain = gallery.querySelector('.buy-box-v6__gallery-main');
    if (galleryMain) {
      galleryMain.addEventListener('touchstart', function(e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
      galleryMain.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) diff > 0 ? showImage(currentIndex + 1) : showImage(currentIndex - 1);
      }, { passive: true });
    }
  }

  /* ========== Option / Variant Selection ========== */
  function initOptionSelection(container, variants) {
    var optionGroups = container.querySelectorAll('.buy-box-v6__option-group');
    if (optionGroups.length === 0 || variants.length === 0) return;

    // Set default selection to match the first variant in the list (admin drag order)
    var firstVariant = variants[0];
    if (firstVariant) {
      optionGroups.forEach(function(group, groupIdx) {
        var buttons = group.querySelectorAll('.buy-box-v6__option-btn');
        var targetValue = firstVariant.options[groupIdx];
        buttons.forEach(function(btn) {
          btn.classList.remove('buy-box-v6__option-btn--active');
          if (btn.dataset.value === targetValue) {
            btn.classList.add('buy-box-v6__option-btn--active');
          }
        });
      });
    }

    // Build current selections from active buttons
    function getSelectedOptions() {
      var selections = [];
      optionGroups.forEach(function(group) {
        var active = group.querySelector('.buy-box-v6__option-btn--active');
        selections.push(active ? active.dataset.value : null);
      });
      return selections;
    }

    function findVariant(selections) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selections.length; j++) {
          if (selections[j] && v.options[j] !== selections[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updatePricing(variant) {
      if (!variant) return;

      var pricingRow = container.querySelector('.buy-box-v6__pricing');
      var priceEl = container.querySelector('.buy-box-v6__price');
      var compareEl = container.querySelector('.buy-box-v6__compare');
      var saveEl = container.querySelector('.buy-box-v6__save-tag');
      var ctaBtn = container.querySelector('.buy-box-v6__cta');
      var vipPriceEl = container.querySelector('.buy-box-v6__vip-price');

      if (pricingRow) pricingRow.dataset.variantId = variant.id;
      if (ctaBtn) ctaBtn.dataset.variantId = variant.id;

      var price = variant.price;
      var compare = variant.compare_at_price;

      if (priceEl) priceEl.textContent = formatMoney(price);

      if (compare && compare > price) {
        if (compareEl) {
          compareEl.textContent = formatMoney(compare);
          compareEl.style.display = '';
        }
        var pct = Math.round((compare - price) / compare * 100);
        if (saveEl) {
          saveEl.textContent = 'SAVE ' + pct + '%';
          saveEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }

      // VIP price = 80% of current price
      if (vipPriceEl) {
        var vipCents = Math.round(price * 0.8);
        vipPriceEl.textContent = 'VIP Members Pay ' + formatMoney(vipCents);
      }

      // Update CTA text and sold-out state
      if (ctaBtn) {
        if (variant.available) {
          var ctaBase = ctaBtn.getAttribute('data-cta-text') || ctaBtn.textContent.split('\u2014')[0].trim();
          ctaBtn.textContent = ctaBase + ' \u2014 ' + formatMoney(price);
          ctaBtn.disabled = false;
          ctaBtn.classList.remove('buy-box-v6__cta--sold-out');
        } else {
          ctaBtn.textContent = 'SOLD OUT';
          ctaBtn.disabled = true;
          ctaBtn.classList.add('buy-box-v6__cta--sold-out');
        }
      }

      // Jump gallery to variant's featured image
      if (variant.featured_image && typeof container._bb6ShowImage === 'function') {
        var targetId = String(variant.featured_image.id);
        var imgs = container.querySelectorAll('.buy-box-v6__gallery-image');
        for (var k = 0; k < imgs.length; k++) {
          if (imgs[k].getAttribute('data-media-id') === targetId) {
            container._bb6ShowImage(k);
            break;
          }
        }
      }
    }

    // Check which option values are available given current selections
    function updateAvailability() {
      optionGroups.forEach(function(group, groupIdx) {
        var buttons = group.querySelectorAll('.buy-box-v6__option-btn');
        buttons.forEach(function(btn) {
          // Build test selections: keep all OTHER groups' active values, swap this one
          var testSelections = [];
          optionGroups.forEach(function(otherGroup, otherIdx) {
            if (otherIdx === groupIdx) {
              testSelections.push(btn.dataset.value);
            } else {
              var active = otherGroup.querySelector('.buy-box-v6__option-btn--active');
              testSelections.push(active ? active.dataset.value : null);
            }
          });
          // Check if ANY variant exists with this combination
          var available = variants.some(function(v) {
            for (var j = 0; j < testSelections.length; j++) {
              if (testSelections[j] && v.options[j] !== testSelections[j]) return false;
            }
            return true;
          });
          btn.classList.toggle('buy-box-v6__option-btn--unavailable', !available);
          btn.disabled = !available;
        });
      });
    }

    // If current selection becomes invalid after availability update, auto-select first available
    function autoCorrectSelections() {
      var changed = false;
      optionGroups.forEach(function(group) {
        var active = group.querySelector('.buy-box-v6__option-btn--active');
        if (active && active.disabled) {
          active.classList.remove('buy-box-v6__option-btn--active');
          var firstAvailable = group.querySelector('.buy-box-v6__option-btn:not([disabled])');
          if (firstAvailable) {
            firstAvailable.classList.add('buy-box-v6__option-btn--active');
            changed = true;
          }
        }
      });
      return changed;
    }

    function onOptionChange() {
      updateAvailability();
      if (autoCorrectSelections()) updateAvailability();
      var selections = getSelectedOptions();
      var variant = findVariant(selections);
      if (variant) {
        updatePricing(variant);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }
    }

    // Click handlers for option buttons
    optionGroups.forEach(function(group) {
      var buttons = group.querySelectorAll('.buy-box-v6__option-btn');
      buttons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          if (this.disabled) return;
          buttons.forEach(function(b) { b.classList.remove('buy-box-v6__option-btn--active'); });
          this.classList.add('buy-box-v6__option-btn--active');
          onOptionChange();
        });
      });
    });

    // Initial: run availability check and sync pricing to first variant
    updateAvailability();
    if (firstVariant) updatePricing(firstVariant);
  }

  /* ========== Quantity ========== */
  function initQuantity(container) {
    var minusBtn = container.querySelector('.buy-box-v6__qty-minus');
    var plusBtn = container.querySelector('.buy-box-v6__qty-plus');
    var input = container.querySelector('.buy-box-v6__qty-input');
    if (!input) return;

    if (minusBtn) minusBtn.addEventListener('click', function() {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });

    if (plusBtn) plusBtn.addEventListener('click', function() {
      var val = parseInt(input.value, 10) || 1;
      if (val < 99) input.value = val + 1;
    });

    input.addEventListener('change', function() {
      var val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) this.value = 1;
      if (val > 99) this.value = 99;
    });
  }

  /* ========== CTA ========== */
  function initCta(container, variants) {
    var cta = container.querySelector('.buy-box-v6__cta');
    if (!cta) return;

    cta.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = this.dataset.variantId;
      var qtyInput = container.querySelector('.buy-box-v6__qty-input');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (variantId) {
        addToCart(variantId, quantity);
      } else {
        console.error('Buy Box V6: No variant ID found');
      }
    });
  }

  /* ========== Add to Cart ========== */
  function addToCart(variantId, quantity) {
    if (!variantId) return;

    var ctaButtons = document.querySelectorAll('.buy-box-v6 .buy-box-v6__cta');
    ctaButtons.forEach(function(btn) {
      btn.classList.add('buy-box-v6__cta--loading');
      btn.disabled = true;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
    })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(err) { throw new Error(err.message || err.description || 'Failed to add to cart'); });
      return response.json();
    })
    .then(function(data) {
      console.log('Buy Box V6: Added to cart', data);
      ctaButtons.forEach(function(btn) { btn.classList.remove('buy-box-v6__cta--loading'); btn.disabled = false; });
      openCartDrawer();
    })
    .catch(function(error) {
      console.error('Buy Box V6: Error adding to cart', error);
      ctaButtons.forEach(function(btn) { btn.classList.remove('buy-box-v6__cta--loading'); btn.disabled = false; });
      alert('Error: ' + error.message);
    });
  }

  /* ========== Format Money (Shopify cents to $XX.XX) ========== */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ========== Open Cart Drawer ========== */
  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));

    var cartTriggers = [
      '[data-cart-trigger]', '.js-cart-trigger', '.cart-icon',
      '[data-action="open-drawer"][data-drawer="cart"]',
      '#cart-icon', '.header__icon--cart', '[href="/cart"]'
    ];

    var drawerOpened = false;
    for (var i = 0; i < cartTriggers.length; i++) {
      var trigger = document.querySelector(cartTriggers[i]);
      if (trigger && typeof trigger.click === 'function') {
        var isDrawerTrigger = trigger.hasAttribute('data-cart-trigger') || trigger.hasAttribute('data-action') || trigger.classList.contains('js-cart-trigger');
        if (isDrawerTrigger) { trigger.click(); drawerOpened = true; break; }
      }
    }

    var drawerSelectors = ['.cart-drawer', '#cart-drawer', '.drawer--cart', '[data-drawer="cart"]', '.mini-cart', '.cart-flyout'];
    for (var j = 0; j < drawerSelectors.length; j++) {
      var drawer = document.querySelector(drawerSelectors[j]);
      if (drawer) {
        drawer.classList.add('is-open', 'active', 'open');
        drawerOpened = true;
        var overlay = document.querySelector('.drawer-overlay, .cart-overlay');
        if (overlay) overlay.classList.add('is-open', 'active');
        break;
      }
    }

    if (!drawerOpened) {
      setTimeout(function() {
        var visible = document.querySelector('.cart-drawer.is-open, .drawer--cart.active, [data-drawer="cart"].open');
        if (!visible) window.location.href = '/cart';
      }, 300);
    }
  }

})();
